import type { NameColour } from "../types/nameColour";

export function convertNameToColour(name: string): NameColour {
    const hash = getHashFromString(name);
    const colourHash = hash % 6;
    return convertNumberToColour(colourHash);
}

function getHashFromString(input: string) {
    let hash = 0;

    for (let i = 0; i < input.length; i++) {
        hash = input.charCodeAt(i) + ((hash << 5) - hash);
    }

    return hash;
}

function convertNumberToColour(colourNum: number): NameColour {
    switch (colourNum) {
        case 0:
        default:
            return "blue";
        case 1:
            return "green";
        case 2:
            return "cyan";
        case 3:
            return "red";
        case 4:
            return "majenta";
        case 5:
            return "orange";
    }
}
